import React from 'react'
import { observable } from 'mobx'
import CartContext from './contexts/CartContext'

function Cart (props) {
  const cart = observable.map()
  const initialCart = JSON.parse(window.localStorage.getItem('cart'))

  if (initialCart && Object.keys(initialCart).length > 0) {
    cart.replace(initialCart)
  }

  return (
    <CartContext.Provider value={cart}>
      {props.children}
    </CartContext.Provider>
  )
}

export default Cart
